import React from "react";

import { cx } from "~/tools/class-variance";

export interface TimeRangeSelectorSectionProps {
	title: string;
	className?: string;
	children?: React.ReactNode;
}

export const TimeRangeSelectorSection: React.FC<TimeRangeSelectorSectionProps> = ({
	className,
	title,
	children,
	...props
}) => (
	<div {...props} className={cx("space-y-3", className)}>
		<div className="font-medium text-gray-800 text-sm">{title}</div>

		{children}
	</div>
);
